module.exports = __webpack_public_path__ + "img/shibai.411ae13d.png";